export enum LOCAL_STORAGE_KEYS{
    TOKEN = "GOLISHTOKEN",
    STAYSIGNEDIN = "staysignedin"
}

export enum APPLICATION_STATES{
    SIGNEDIN = "SignedIn",
    SIGNEDOUT = "SignedOut"
}

export enum ROLES{
    ADMIN = "ADMIN"
}